import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const AttachmentsMacroUploadLoader: LoadableType<{
	contentId: string;
	onFilesUploaded: (fileNames: string[]) => void;
}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-attachments-macro-upload" */ './AttachmentsMacroUpload.tsx'
			)
		).AttachmentsMacroUpload,
});
